<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="6" class="text-center">
        <h2>Test Cloud Function</h2>
        <v-form @submit.prevent="callCloudFunction">
          <v-text-field v-model="consumer_firstname" label="Consumer First Name" required class="mt-4" />
          <v-text-field v-model="consumer_surname" label="Consumer Surname" required class="mt-4" />
          <v-text-field v-model="consumer_contact_number" label="Consumer Contact Number" required class="mt-4" />
          <v-text-field v-model="consumer_id_number" label="Consumer ID Number" required class="mt-4" />
          <v-btn color="primary" type="submit" :loading="loading" class="mt-4">
            Trigger Cloud Function
          </v-btn>
        </v-form>
        <div class="mt-2 grey--text text--darken-1" style="font-size: 0.9em;">
          Endpoint: <code>https://us-central1-medicare-1022d.cloudfunctions.net/testCriminalCheck</code>
        </div>
        <div v-if="response" class="mt-4">
          <b>Response:</b>
          <pre>{{ response }}</pre>
        </div>
        <div v-if="error" class="mt-4 red--text">
          <b>Error:</b>
          <pre>{{ error }}</pre>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      response: null,
      error: null,
      consumer_firstname: '',
      consumer_surname: '',
      consumer_contact_number: '',
      consumer_id_number: '',
    };
  },
  methods: {
    async callCloudFunction() {
      this.loading = true;
      this.response = null;
      this.error = null;
      try {
        const res = await fetch('https://us-central1-medicare-1022d.cloudfunctions.net/testCriminalCheck', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            consumer_firstname: this.consumer_firstname,
            consumer_surname: this.consumer_surname,
            consumer_contact_number: this.consumer_contact_number,
            consumer_id_number: this.consumer_id_number,
          }),
        });
        let data;
        try {
          data = await res.json();
        } catch (e) {
          data = await res.text();
        }
        if (!res.ok) {
          this.error = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
        } else {
          this.response = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
        }
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
pre {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 6px;
  text-align: left;
  overflow-x: auto;
}
</style>
